import * as AT from "./actionTypes";
import { ExportService } from "../services";
import { SET_EXPORT_JOB_ID } from "./mutationTypes";
export default {
  [AT.SAVE_CONSIGNEE]: (context, formData) => {
    return ExportService.saveConsignee(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_CONSIGNEES]: (context, country) => {
    return ExportService.getConsignees(country)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GET_EXPORT_JOBS]: (context, formData) => {
    return ExportService.getExportJobs(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.EDIT_EXPORT_JOB]: (context, formData) => {
    return ExportService.editExportJob(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.DELETE_EXPORT_JOB]: (context, formData) => {
    return ExportService.deleteExportJob(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.SAVE_EXPORT_JOB]: (context, formData) => {
    return ExportService.saveExportJob(formData)
      .then(response => {
        context.commit(SET_EXPORT_JOB_ID, response.data);
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GENERATE_CHECKLIST]: (context, formData) => {
    return ExportService.generateChecklist(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  },
  [AT.GENERATE_FLATFILE]: (context, formData) => {
    return ExportService.generateFlatfile(formData)
      .then(response => {
        return response;
      })
      .catch(error => Promise.reject(error.response));
  }
};
